// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  background: var(--preset-card, #1e1e1e);
  position: relative;
}

.tab-buttons {
  display: flex;
  gap: 2px;
  margin-right: 4px;
}
.tab-buttons button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0;
  border: none;
  background: transparent;
  color: var(--preset-foreground, #93a1a1);
  cursor: pointer;
  border-radius: 3px;
  opacity: 0.6;
  transition: opacity 0.15s, background 0.15s;
}
.tab-buttons button mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}
.tab-buttons button:hover {
  opacity: 1;
  background: rgba(255, 255, 255, 0.1);
}
.tab-buttons button.active {
  opacity: 1;
  background: rgba(255, 255, 255, 0.15);
}

.action-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0;
  border: none;
  background: transparent;
  color: var(--preset-foreground, #93a1a1);
  cursor: pointer;
  border-radius: 3px;
  opacity: 0.8;
  transition: opacity 0.15s, background 0.15s;
}
.action-btn mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}
.action-btn:hover {
  opacity: 1;
  background: rgba(255, 255, 255, 0.1);
}
.action-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.discard-btn {
  opacity: 0.6;
}

.markdown-container {
  flex: 1;
  position: relative;
  overflow: auto !important;
  overflow-y: auto !important;
  overflow-x: hidden !important;
  padding: 1rem;
  min-height: 0;
  height: 0;
  scrollbar-width: thin;
  scrollbar-color: rgba(155, 155, 155, 0.7) transparent;
}
.markdown-container.gridster-item-content {
  overflow: auto !important;
  overflow-y: auto !important;
  overflow-x: hidden !important;
}
.markdown-container::-webkit-scrollbar {
  width: 8px;
}
.markdown-container::-webkit-scrollbar-track {
  background: transparent;
}
.markdown-container::-webkit-scrollbar-thumb {
  background: rgba(155, 155, 155, 0.7);
  border-radius: 4px;
}
.markdown-container::-webkit-scrollbar-thumb:hover {
  background: rgba(155, 155, 155, 0.9);
}
.markdown-container .loading-overlay,
.markdown-container .error-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.1);
  gap: 12px;
}
.markdown-container .error-overlay {
  color: #f44336;
}
.markdown-container .error-overlay mat-icon {
  font-size: 48px;
  width: 48px;
  height: 48px;
}
.markdown-container .markdown-content {
  min-height: 100%;
  padding-bottom: 1rem;
}
.markdown-container .markdown-content ::ng-deep h1, .markdown-container .markdown-content ::ng-deep h2, .markdown-container .markdown-content ::ng-deep h3, .markdown-container .markdown-content ::ng-deep h4, .markdown-container .markdown-content ::ng-deep h5, .markdown-container .markdown-content ::ng-deep h6 {
  margin-top: 1.5em;
  margin-bottom: 0.5em;
}
.markdown-container .markdown-content ::ng-deep h1:first-child, .markdown-container .markdown-content ::ng-deep h2:first-child, .markdown-container .markdown-content ::ng-deep h3:first-child, .markdown-container .markdown-content ::ng-deep h4:first-child, .markdown-container .markdown-content ::ng-deep h5:first-child, .markdown-container .markdown-content ::ng-deep h6:first-child {
  margin-top: 0;
}
.markdown-container .markdown-content ::ng-deep p {
  margin: 0.75em 0;
  line-height: 1.6;
}
.markdown-container .markdown-content ::ng-deep code {
  background: rgba(128, 128, 128, 0.2);
  padding: 0.2em 0.4em;
  border-radius: 3px;
  font-family: "Fira Code", "Consolas", monospace;
  font-size: 0.9em;
}
.markdown-container .markdown-content ::ng-deep pre {
  background: rgba(0, 0, 0, 0.3);
  padding: 1em;
  border-radius: 4px;
  overflow-x: auto;
}
.markdown-container .markdown-content ::ng-deep pre code {
  background: transparent;
  padding: 0;
}
.markdown-container .markdown-content ::ng-deep blockquote {
  border-left: 4px solid rgba(128, 128, 128, 0.5);
  margin: 1em 0;
  padding-left: 1em;
  color: rgba(255, 255, 255, 0.7);
}
.markdown-container .markdown-content ::ng-deep ul, .markdown-container .markdown-content ::ng-deep ol {
  margin: 0.75em 0;
  padding-left: 2em;
}
.markdown-container .markdown-content ::ng-deep li {
  margin: 0.25em 0;
}
.markdown-container .markdown-content ::ng-deep a {
  color: #64b5f6;
  text-decoration: none;
}
.markdown-container .markdown-content ::ng-deep a:hover {
  text-decoration: underline;
}
.markdown-container .markdown-content ::ng-deep table {
  border-collapse: collapse;
  margin: 1em 0;
  width: 100%;
}
.markdown-container .markdown-content ::ng-deep table th, .markdown-container .markdown-content ::ng-deep table td {
  border: 1px solid rgba(128, 128, 128, 0.3);
  padding: 0.5em 0.75em;
  text-align: left;
}
.markdown-container .markdown-content ::ng-deep table th {
  background: rgba(128, 128, 128, 0.2);
}
.markdown-container .markdown-content ::ng-deep table tr:nth-child(even) {
  background: rgba(128, 128, 128, 0.1);
}
.markdown-container .markdown-content ::ng-deep hr {
  border: none;
  border-top: 1px solid rgba(128, 128, 128, 0.3);
  margin: 2em 0;
}
.markdown-container .markdown-content ::ng-deep img {
  max-width: 100%;
  height: auto;
}

:host-context(.dockview-panel-host) ::ng-deep app-widget-titlebar {
  display: none;
}

.floating-toolbar {
  display: none;
  position: absolute;
  top: 6px;
  right: 12px;
  z-index: 10;
  align-items: center;
  gap: 2px;
  background: var(--preset-card, #1e1e1e);
  border: 1px solid rgba(128, 128, 128, 0.25);
  border-radius: 4px;
  padding: 2px;
  opacity: 0.7;
  transition: opacity 0.15s;
}
:host-context(.dockview-panel-host) .floating-toolbar {
  display: flex;
}
.floating-toolbar:hover {
  opacity: 1;
}
.floating-toolbar button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  padding: 0;
  border: none;
  background: transparent;
  color: var(--preset-foreground, #93a1a1);
  cursor: pointer;
  border-radius: 3px;
}
.floating-toolbar button mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}
.floating-toolbar button:hover {
  background: rgba(255, 255, 255, 0.1);
}
.floating-toolbar button.active {
  background: rgba(255, 255, 255, 0.15);
  color: var(--preset-primary, #64b5f6);
}
.floating-toolbar button:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.floating-toolbar .divider {
  width: 1px;
  height: 18px;
  background: rgba(128, 128, 128, 0.3);
  margin: 0 2px;
}

.editor-container {
  flex: 1;
  min-height: 0;
  overflow: hidden;
}`, "",{"version":3,"sources":["webpack://./src/app/components/strategy-grid/markdown-widget/markdown-widget.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,WAAA;EACA,uCAAA;EACA,kBAAA;AACF;;AAGA;EACE,aAAA;EACA,QAAA;EACA,iBAAA;AAAF;AAEE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,uBAAA;EACA,wCAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,2CAAA;AAAJ;AAEI;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAAN;AAGI;EACE,UAAA;EACA,oCAAA;AADN;AAII;EACE,UAAA;EACA,qCAAA;AAFN;;AAQA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,uBAAA;EACA,wCAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,2CAAA;AALF;AAOE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AALJ;AAQE;EACE,UAAA;EACA,oCAAA;AANJ;AASE;EACE,YAAA;EACA,mBAAA;AAPJ;;AAWA;EACE,YAAA;AARF;;AAWA;EACE,OAAA;EACA,kBAAA;EACA,yBAAA;EACA,2BAAA;EACA,6BAAA;EACA,aAAA;EACA,aAAA;EACA,SAAA;EAUA,qBAAA;EACA,qDAAA;AAjBF;AASE;EACE,yBAAA;EACA,2BAAA;EACA,6BAAA;AAPJ;AAcE;EACE,UAAA;AAZJ;AAcE;EACE,uBAAA;AAZJ;AAcE;EACE,oCAAA;EACA,kBAAA;AAZJ;AAcI;EACE,oCAAA;AAZN;AAgBE;;EAEE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;AAdJ;AAiBE;EACE,cAAA;AAfJ;AAiBI;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAfN;AAmBE;EACE,gBAAA;EACA,oBAAA;AAjBJ;AAqBM;EACE,iBAAA;EACA,oBAAA;AAnBR;AAqBQ;EACE,aAAA;AAnBV;AAuBM;EACE,gBAAA;EACA,gBAAA;AArBR;AAwBM;EACE,oCAAA;EACA,oBAAA;EACA,kBAAA;EACA,+CAAA;EACA,gBAAA;AAtBR;AAyBM;EACE,8BAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;AAvBR;AAyBQ;EACE,uBAAA;EACA,UAAA;AAvBV;AA2BM;EACE,+CAAA;EACA,aAAA;EACA,iBAAA;EACA,+BAAA;AAzBR;AA4BM;EACE,gBAAA;EACA,iBAAA;AA1BR;AA6BM;EACE,gBAAA;AA3BR;AA8BM;EACE,cAAA;EACA,qBAAA;AA5BR;AA8BQ;EACE,0BAAA;AA5BV;AAgCM;EACE,yBAAA;EACA,aAAA;EACA,WAAA;AA9BR;AAgCQ;EACE,0CAAA;EACA,qBAAA;EACA,gBAAA;AA9BV;AAiCQ;EACE,oCAAA;AA/BV;AAkCQ;EACE,oCAAA;AAhCV;AAoCM;EACE,YAAA;EACA,8CAAA;EACA,aAAA;AAlCR;AAqCM;EACE,eAAA;EACA,YAAA;AAnCR;;AA2CE;EACE,aAAA;AAxCJ;;AA6CA;EACE,aAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,QAAA;EACA,uCAAA;EACA,2CAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,yBAAA;AA1CF;AA4CE;EACE,aAAA;AA1CJ;AA6CE;EACE,UAAA;AA3CJ;AA8CE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,uBAAA;EACA,wCAAA;EACA,eAAA;EACA,kBAAA;AA5CJ;AA8CI;EACE,eAAA;EACA,WAAA;EACA,YAAA;AA5CN;AA+CI;EACE,oCAAA;AA7CN;AAgDI;EACE,qCAAA;EACA,qCAAA;AA9CN;AAiDI;EACE,YAAA;EACA,mBAAA;AA/CN;AAmDE;EACE,UAAA;EACA,YAAA;EACA,oCAAA;EACA,aAAA;AAjDJ;;AAsDA;EACE,OAAA;EACA,aAAA;EACA,gBAAA;AAnDF","sourcesContent":[":host {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  width: 100%;\n  background: var(--preset-card, #1e1e1e);\n  position: relative;\n}\n\n// Tab buttons in titlebar\n.tab-buttons {\n  display: flex;\n  gap: 2px;\n  margin-right: 4px;\n\n  button {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 24px;\n    height: 24px;\n    padding: 0;\n    border: none;\n    background: transparent;\n    color: var(--preset-foreground, #93a1a1);\n    cursor: pointer;\n    border-radius: 3px;\n    opacity: 0.6;\n    transition: opacity 0.15s, background 0.15s;\n\n    mat-icon {\n      font-size: 16px;\n      width: 16px;\n      height: 16px;\n    }\n\n    &:hover {\n      opacity: 1;\n      background: rgba(255, 255, 255, 0.1);\n    }\n\n    &.active {\n      opacity: 1;\n      background: rgba(255, 255, 255, 0.15);\n    }\n  }\n}\n\n// Action buttons (save, discard)\n.action-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  padding: 0;\n  border: none;\n  background: transparent;\n  color: var(--preset-foreground, #93a1a1);\n  cursor: pointer;\n  border-radius: 3px;\n  opacity: 0.8;\n  transition: opacity 0.15s, background 0.15s;\n\n  mat-icon {\n    font-size: 16px;\n    width: 16px;\n    height: 16px;\n  }\n\n  &:hover {\n    opacity: 1;\n    background: rgba(255, 255, 255, 0.1);\n  }\n\n  &:disabled {\n    opacity: 0.4;\n    cursor: not-allowed;\n  }\n}\n\n.discard-btn {\n  opacity: 0.6;\n}\n\n.markdown-container {\n  flex: 1;\n  position: relative;\n  overflow: auto !important;\n  overflow-y: auto !important;  // Extra specificity to override gridster-item-content rules\n  overflow-x: hidden !important;\n  padding: 1rem;\n  min-height: 0; // Required for flex child to respect overflow\n  height: 0; // Force flex-based sizing to enable scrolling in app pane\n\n  // Override the global gridster-item-content overflow:visible rule\n  &.gridster-item-content {\n    overflow: auto !important;\n    overflow-y: auto !important;\n    overflow-x: hidden !important;\n  }\n\n  // Themed scrollbar\n  scrollbar-width: thin;\n  scrollbar-color: rgba(155, 155, 155, 0.7) transparent;\n\n  &::-webkit-scrollbar {\n    width: 8px;\n  }\n  &::-webkit-scrollbar-track {\n    background: transparent;\n  }\n  &::-webkit-scrollbar-thumb {\n    background: rgba(155, 155, 155, 0.7);\n    border-radius: 4px;\n\n    &:hover {\n      background: rgba(155, 155, 155, 0.9);\n    }\n  }\n\n  .loading-overlay,\n  .error-overlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    background: rgba(0, 0, 0, 0.1);\n    gap: 12px;\n  }\n\n  .error-overlay {\n    color: #f44336;\n\n    mat-icon {\n      font-size: 48px;\n      width: 48px;\n      height: 48px;\n    }\n  }\n\n  .markdown-content {\n    min-height: 100%;\n    padding-bottom: 1rem; // Bottom \"margin\" inside scrollable area\n\n    // Markdown styling\n    ::ng-deep {\n      h1, h2, h3, h4, h5, h6 {\n        margin-top: 1.5em;\n        margin-bottom: 0.5em;\n\n        &:first-child {\n          margin-top: 0;\n        }\n      }\n\n      p {\n        margin: 0.75em 0;\n        line-height: 1.6;\n      }\n\n      code {\n        background: rgba(128, 128, 128, 0.2);\n        padding: 0.2em 0.4em;\n        border-radius: 3px;\n        font-family: 'Fira Code', 'Consolas', monospace;\n        font-size: 0.9em;\n      }\n\n      pre {\n        background: rgba(0, 0, 0, 0.3);\n        padding: 1em;\n        border-radius: 4px;\n        overflow-x: auto;\n\n        code {\n          background: transparent;\n          padding: 0;\n        }\n      }\n\n      blockquote {\n        border-left: 4px solid rgba(128, 128, 128, 0.5);\n        margin: 1em 0;\n        padding-left: 1em;\n        color: rgba(255, 255, 255, 0.7);\n      }\n\n      ul, ol {\n        margin: 0.75em 0;\n        padding-left: 2em;\n      }\n\n      li {\n        margin: 0.25em 0;\n      }\n\n      a {\n        color: #64b5f6;\n        text-decoration: none;\n\n        &:hover {\n          text-decoration: underline;\n        }\n      }\n\n      table {\n        border-collapse: collapse;\n        margin: 1em 0;\n        width: 100%;\n\n        th, td {\n          border: 1px solid rgba(128, 128, 128, 0.3);\n          padding: 0.5em 0.75em;\n          text-align: left;\n        }\n\n        th {\n          background: rgba(128, 128, 128, 0.2);\n        }\n\n        tr:nth-child(even) {\n          background: rgba(128, 128, 128, 0.1);\n        }\n      }\n\n      hr {\n        border: none;\n        border-top: 1px solid rgba(128, 128, 128, 0.3);\n        margin: 2em 0;\n      }\n\n      img {\n        max-width: 100%;\n        height: auto;\n      }\n    }\n  }\n}\n\n// In dockview mode, hide the widget titlebar (dockview provides its own tab header)\n:host-context(.dockview-panel-host) {\n  ::ng-deep app-widget-titlebar {\n    display: none;\n  }\n}\n\n// Floating toolbar — visible in dockview mode, hidden in gridster mode\n.floating-toolbar {\n  display: none; // Hidden by default (gridster mode — titlebar has the buttons)\n  position: absolute;\n  top: 6px;\n  right: 12px;\n  z-index: 10;\n  align-items: center;\n  gap: 2px;\n  background: var(--preset-card, #1e1e1e);\n  border: 1px solid rgba(128, 128, 128, 0.25);\n  border-radius: 4px;\n  padding: 2px;\n  opacity: 0.7;\n  transition: opacity 0.15s;\n\n  :host-context(.dockview-panel-host) & {\n    display: flex; // Show in dockview mode\n  }\n\n  &:hover {\n    opacity: 1;\n  }\n\n  button {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 26px;\n    height: 26px;\n    padding: 0;\n    border: none;\n    background: transparent;\n    color: var(--preset-foreground, #93a1a1);\n    cursor: pointer;\n    border-radius: 3px;\n\n    mat-icon {\n      font-size: 16px;\n      width: 16px;\n      height: 16px;\n    }\n\n    &:hover {\n      background: rgba(255, 255, 255, 0.1);\n    }\n\n    &.active {\n      background: rgba(255, 255, 255, 0.15);\n      color: var(--preset-primary, #64b5f6);\n    }\n\n    &:disabled {\n      opacity: 0.4;\n      cursor: not-allowed;\n    }\n  }\n\n  .divider {\n    width: 1px;\n    height: 18px;\n    background: rgba(128, 128, 128, 0.3);\n    margin: 0 2px;\n  }\n}\n\n// Monaco editor container\n.editor-container {\n  flex: 1;\n  min-height: 0;\n  overflow: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
